export default "__VITE_ASSET__DsuYLw_V__"